import React from "react";

// Tiny inline sparkline comparing delivered vs opened for one campaign —
// no charting library needed for a single-glance trend indicator, and it
// stays theme-token correct in both light/dark automatically.
const TrendSparkline = ({ sent = 0, opened = 0, width = 64, height = 22 }) => {
  const ratio = sent > 0 ? Math.min(opened / sent, 1) : 0;
  const points = [0, 0.35, 0.6, 0.8, 1].map((t) => t * ratio + (1 - t) * 0.15);

  const stepX = width / (points.length - 1);
  const path = points
    .map((p, i) => `${i === 0 ? "M" : "L"}${(i * stepX).toFixed(1)},${(height - p * height).toFixed(1)}`)
    .join(" ");

  if (sent === 0) {
    return <span className="text-[11px] text-text_muted">—</span>;
  }

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} className="overflow-visible">
      <path d={path} fill="none" stroke="var(--color-primary)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx={width} cy={height - points[points.length - 1] * height} r="2" fill="var(--color-primary)" />
    </svg>
  );
};

export default TrendSparkline;
